export const IMAGES = {
  LOGOS: {
    HAMILA_CENTER: {
      24: require("./logos/hamila-center/24.png"),
      main: require("./logos/hamila-center/main.png"),
    },
  },
  LOADING_SPINNER: {
    HAMILA_CENTER: require("./loading-spinner/hamila-center.gif"),
  },
  LOCATION: {
    HAMILA_CENTER: require("./location/hamila-center.png"),
  },
  GALLERY: {
    HAMILA_CENTER: [
      require("./gallery/hamila-center/1.jpg"),
      require("./gallery/hamila-center/2.png"),
      require("./gallery/hamila-center/3.jpg"),
    ],
  },
};
